import React from 'react';
import { Button as BaseButton, Stack, Typography } from '@mui/material';
import { IButton } from './interfaces';

export const Button: React.FC<IButton> = ({
  label,
  icon: Icon,
  onClick,
  disabled = false,
}): JSX.Element => {
  return (
    <BaseButton
      sx={{
        padding: '10px',
        border: '1px solid #dfe6e9',
      }}
      startIcon={<Icon></Icon>}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
    </BaseButton>
  );
};
